import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800"
}
const _hoisted_2 = {
  key: 0,
  class: "text-orange-600 pl-0.5"
}
const _hoisted_3 = {
  class: /*@__PURE__*/_normalizeClass(` relative mt-1 flex w-full flex-col justify-center`)
}
const _hoisted_4 = {
  key: 1,
  class: "error-message text-sm text-error"
}
const _hoisted_5 = {
  key: 2,
  class: "rounded-sm bg-success p-2 text-sm text-white"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxTextBox = _resolveComponent("DxTextBox")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${_ctx.noPadding ? 'py-0' : 'py-3'} w-full ${_ctx.isLabelInFrontInput && 'mb-1 flex items-center space-x-2'}`)
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.label), 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_DxTextBox, {
        class: _normalizeClass(`w-full border p-1 text-lg leading-normal ${
          _ctx.isError ? 'border-error' : 'border-[#dee1e3]'
        } !important relative appearance-none bg-white text-left font-sans text-dark shadow-sm  outline-none focus:border-primary ${
          _ctx.isSuccess ? 'mb-2 border-success' : ''
        }`),
        mask: _ctx.mask,
        "use-masked-value": _ctx.useMaskValue,
        "show-mask-mode": _ctx.showMaskMode,
        "mask-rules": _ctx.maskRules,
        "input-attr": _ctx.inputAttr,
        "mask-invalid-message": _ctx.maskInvalidMessage,
        "show-clear-button": _ctx.showClearButton,
        "value-change-event": _ctx.valueChangeEvent,
        value: _ctx.value,
        "v-model:value": _ctx.vModel,
        onValueChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('value-changed', $event)))
      }, null, 8, ["class", "mask", "use-masked-value", "show-mask-mode", "mask-rules", "input-attr", "mask-invalid-message", "show-clear-button", "value-change-event", "value", "v-model:value"])
    ]),
    (_ctx.isError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    (_ctx.isSuccess)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.successMessage), 1))
      : _createCommentVNode("", true)
  ], 2))
}